import type { FC } from 'react';
import { Checkbox, CheckboxGroup, FeatureFlags, Modal, Stack } from '@carbon/react';

import type { EscolhaDosPerfis } from '../../logica/perfis/useEscolhaDosPerfis';
import { ROTULOS } from './rotulos';

// QUAIS PERFIS LIBERAR — o modal do Carbon com os perfis travados da conta em caixas de marcar.
// O texto diz o que muda; a contagem diz quantos faltam; o botão só acende com a quantidade certa,
// e as caixas além do limite ficam desligadas. Usado ao contratar mais perfis com perfis travados
// (QA de pagamentos, C5): não há troca entre os perfis da conta, só liberar contratando mais.

export const EscolherPerfisAtivos: FC<{ e: EscolhaDosPerfis }> = ({ e }) => (
  <FeatureFlags enableFocusWrapWithoutSentinels>
    <Modal
      open={e.aberto}
      size='sm'
      modalLabel='Perfis de artista'
      modalHeading={e.titulo}
      primaryButtonText={e.acao}
      secondaryButtonText='Voltar'
      primaryButtonDisabled={!e.podeConfirmar}
      loadingStatus={e.emCurso ? 'active' : 'inactive'}
      loadingDescription='Um momento…'
      onRequestSubmit={() => { if (e.podeConfirmar) e.confirmar(); }}
      onRequestClose={e.fechar}
      closeButtonLabel={ROTULOS.fechar}
    >
      <Stack gap={5}>
        <p>{e.texto}</p>
        <CheckboxGroup legendText={e.contagem}>
          {e.perfis.map((p) => (
            <Checkbox
              key={p.id}
              id={`perfil-ativo-${p.id}`}
              labelText={p.nome}
              helperText={p.apoio}
              checked={p.marcado}
              disabled={p.desabilitado}
              onChange={() => e.alternar(p.id)}
            />
          ))}
        </CheckboxGroup>
      </Stack>
    </Modal>
  </FeatureFlags>
);
